// Cinematic intros need the scene immediately; legacy splash screens defer construction.
export function scheduleSceneStartup(start) {
  let cancelled=false, started=false, frame=0;
  const cinematic=Boolean(document.querySelector('[data-cinematic]'));
  const begin=()=>{
    if(cancelled || started) return;
    started=true;clearTimeout(timer);
    window.removeEventListener('codex-splash-settled',begin);
    // The four-shot intro cannot paint until the scene exists. Waiting for
    // two empty frames here only delays its first image.
    if(cinematic) { start(); return; }
    frame=requestAnimationFrame(()=>{
      frame=requestAnimationFrame(()=>{if(!cancelled) start();});
    });
  };
  const covered=Boolean(document.querySelector('.brand-splash'));
  const delay=covered && !cinematic && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 4000 : 0;
  const timer=setTimeout(begin,delay);
  window.addEventListener('codex-splash-settled',begin);
  return ()=>{cancelled=true;clearTimeout(timer);cancelAnimationFrame(frame);window.removeEventListener('codex-splash-settled',begin);};
}
